import { IconButton, Link, Icon } from '@nimbus-ds/components';
import { CopyIcon, TrashIcon, PlusCircleIcon } from '@nimbus-ds/icons';
import { WeekdaysType } from '@tiendanube/common';
import { Stack, useResponsive } from 'commons/components';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';
import { ExtendedBusinessHoursResponseDto } from '../utils';

interface BusinessHourActionsProps {
  day: WeekdaysType;
  isDayChanged: boolean;
  businessHours: ExtendedBusinessHoursResponseDto[];
  handleApplyAll: (newBusinessHour: ExtendedBusinessHoursResponseDto) => void;
  handleAddBusinessHour: (day: WeekdaysType) => void;
  handleRemoveBusinessHour: (day: WeekdaysType) => void;
}

function BusinessHourActions({
  day,
  isDayChanged,
  businessHours,
  handleApplyAll,
  handleAddBusinessHour,
  handleRemoveBusinessHour,
}: Readonly<BusinessHourActionsProps>): JSX.Element {
  const t = useTranslationShipping(
    'deliveryMethods.pickupPoints.form.secondStep.businessHours',
  );
  const { isMobile } = useResponsive();

  const hasMultipleBusinessHours = businessHours.length > 1;
  const isLastBusinessHour = businessHours.length === 1;

  const lastIndex = businessHours.length - 1;

  return (
    <Stack
      gap="4"
      spacing="tight"
      align="center"
      aria-label="Business hour actions"
    >
      {hasMultipleBusinessHours && (
        <IconButton
          backgroundColor="transparent"
          borderColor="transparent"
          size="1.3rem"
          aria-label={t('delete')}
          aria-describedby={`delete-${day}-${lastIndex}`}
          source={<TrashIcon size="small" />}
          onClick={() => handleRemoveBusinessHour(day)}
        />
      )}

      {isLastBusinessHour && (
        <IconButton
          backgroundColor="transparent"
          borderColor="transparent"
          size="1.3rem"
          aria-label={t('add')}
          aria-describedby={`add-${day}`}
          source={<PlusCircleIcon size="small" />}
          onClick={() => handleAddBusinessHour(day)}
        />
      )}

      {isDayChanged && !isMobile && (
        <Link
          textDecoration="none"
          appearance="neutral"
          as="button"
          onClick={() => handleApplyAll(businessHours[0])}
          aria-label={t('applyAll')}
        >
          <Icon color="currentColor" source={<CopyIcon size="small" />} />{' '}
          {t('applyAll')}
        </Link>
      )}
    </Stack>
  );
}

export default BusinessHourActions;
